module.exports = __webpack_public_path__ + "static/img/logo.d6f6d2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/common/logo.png
// module id = r2b+
// module chunks = 7